import { makeStyles, shorthands } from "@fluentui/react-components";

export const useStyles = makeStyles({
  microsoftAvatarContainer: {
    height: "20px",
    width: "20px",
  },
  avatar: {
    marginLeft: "0px",
    height: "20px",
    width: "20px",
  },
  iconOnly: {
    "> span": {
      paddingLeft: "1px",
      paddingRight: "1px",
    },
    paddingRight: "0px",
    marginRight: "0px",
  },
  srOnly: {
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: "auto",
    position: "absolute",
    width: "1px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    ...shorthands.border("0px"),
    ...shorthands.margin("0px"),
    ...shorthands.padding("0px"),
  },
});
